const rem = (px: number) => `${px / 16}rem`;

export default rem;
